
<script setup lang="ts">
import Cta from './components/ui/Cta.vue';

const error = useError();
const title = ref<string>();
const href = ref<string>('');

const handleClick = () => {
    window.location.replace(href.value)
}
 
onMounted(() => {
    switch (error.value?.statusCode) {
        case 404:
            title.value = 'Pagina non trovata'
        break;
        case 403:
            title.value = 'Questa pagina non è disponibile'
        break;
        default:
            title.value = 'Abbiamo riscontrato un errore'
        break;
    }
    href.value = useRequestURL().origin
})
</script>

<template>
    <NuxtLayout>
        <div class="logo-wrapper bg-white py-2">
            <div class="w-11/12 sm:max-w-7xl mx-auto flex flex-wrap justify-center items-center">
                <div class="h-14">
                    <img
                    alt="Cofidis logo"
                    class="w-[112px] h-[52px]"
                    src="/images/static/logo.svg"
                    />
                </div>
            </div>
        </div>
        <div class="px-4 my-12 w-full">
            <div class="bg-white container mx-auto rounded-xl px-4 pt-6 pb-12 flex flex-col items-center justify-center min-h-[40vh]">
                <h1 class="text-3xl text-center font-semibold">{{ title }}</h1>
                <div class="mt-8">
                    <!-- <a href="" class="uppercase font-semibold border-b-2 border-red text-red">Torna alla Home</a> -->
                    <Cta :href="href" @click="handleClick" text="Torna alla Home" class="!text-base !leading-tight text-center"></Cta>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>